function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9 .24a6 6 0 100 12 6 6 0 000-12zm0 8.75L6.25 6.24 9 3.5l2.75 2.74L9 8.99z",
  fill: "#5A6689"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 18.24V13.8H3v4.44h12z",
  fill: "#9199B1"
});

function SvgWalletinline(props) {
  return React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgWalletinline;